import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field } from 'redux-form';

import { TextField } from 'redux-form-material-ui'

import { changePort } from 'actions/regions/ports';
import { numericality,inclusion } from "redux-form-validators";

const styles = {
    textField: {
        floatingLabelStyle:
            {
                fontSize: '12px',
            },
    },
};

class PortRestrictions extends React.Component {
    constructor(props) {
       super(props);

       this.changeField = this.changeField.bind(this);
    }

    changeField() {
        this.props.changePort(this.props.forms[formName].values);
    }

    render() {
        return (
            <Fragment>
                <div className="main__title">
                    PORT Restrictions
                </div>

                <div className="port-restrictions">
                        <div className="list">
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.maxDraught'}
                                    floatingLabelText='Max Draft, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true }), ]}
                                    fullWidth
                                />
                            </div>
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.maxBeam'}
                                    floatingLabelText='Max Beam, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true  })]}
                                    fullWidth
                                />
                            </div>
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.maxLOA'}
                                    floatingLabelText='Max LOA, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[numericality({ '>=': 0, '<=': 1000, allowBlank: true  })]}
                                    fullWidth
                                />
                            </div>
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.maxDWT'}
                                    floatingLabelText='Max DWT, mt:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[numericality({ '>=': 0, '<=': 1000000, allowBlank: true  })]}
                                    fullWidth
                                />
                            </div>
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.channelDepth'}
                                    floatingLabelText='Channel Depth, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[ numericality({ '>=': 0, '<=': 100, allowBlank: true  })]}
                                    fullWidth
                                />
                            </div>
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.anchorageDepth'}
                                    floatingLabelText='Anchorage Depth, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true  })]}
                                    fullWidth
                                />
                            </div>
                            <div className="item">
                                <Field
                                    component={TextField}
                                    name={'portLimitations.meanTide'}
                                    floatingLabelText='Mean Tide, m:'
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true  })]}
                                    fullWidth
                                />
                            </div>
                        </div>
                </div>
            </Fragment>)

    }
}

PortRestrictions.propTypes = {

};

PortRestrictions.defaultProps = {

};

export default connect(
    ({ form }) => {
        return {
            forms: form,
        };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(PortRestrictions);


// WEBPACK FOOTER //
// ./app/components/Regions/Port/PortRestrictions.jsx